// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"399":"e0a347d0","480":"3ffc9e4b","984":"7bb62b33"}[chunkId] + ".chunk.css";
};